(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-discount-dawn4"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ft-cart-discount-dawn4')) {
    class FCDawn4 extends HTMLElement {
      static normalize(code) { return String(code || '').trim().toUpperCase(); }

      static applications(cart) {
        return [
          ...(cart.cart_level_discount_applications || []),
          ...(cart.discount_applications || []),
          ...(cart.items || []).flatMap((item) =>
            (item.line_level_discount_allocations || []).map((allocation) => allocation.discount_application)
          )
        ].filter(Boolean);
      }

      static codes(cart) {
        const values = Array.isArray(cart.discount_codes)
          ? cart.discount_codes.filter((item) => item.applicable !== false).map((item) => item.code)
          : FCDawn4.applications(cart).filter((item) => item.type === 'discount_code').map((item) => item.title);
        const unique = new Map();
        values.forEach((value) => {
          const code = String(value || '').trim();
          if (code) unique.set(FCDawn4.normalize(code), code);
        });
        return [...unique.values()];
      }

      static feedback(cart, code, removing) {
        if (removing) {
          const remains = FCDawn4.codes(cart).some((value) => FCDawn4.normalize(value) === FCDawn4.normalize(code));
          return remains ? 'Der Code konnte nicht entfernt werden. Bitte lade den Warenkorb neu.' : 'Rabattcode entfernt.';
        }
        const key = FCDawn4.normalize(code);
        const entry = (cart.discount_codes || []).find((item) => FCDawn4.normalize(item.code) === key);
        if (entry?.applicable === false) {
          return 'Dieser Code ist für den aktuellen Warenkorb nicht anwendbar. Bitte prüfe Schreibweise, Mindestbestellwert und Rabattbedingungen.';
        }
        const applied = FCDawn4.applications(cart).some((item) =>
          item.type === 'discount_code' && FCDawn4.normalize(item.title) === key && item.target_type !== 'shipping_line'
        );
        if (applied) return 'Rabattcode angewendet. Die Preise wurden aktualisiert.';
        if (entry?.applicable === true) {
          return 'Rabattcode übernommen. Ein möglicher Versandrabatt oder weitere Bedingungen werden im Checkout berücksichtigt.';
        }
        return 'Für diesen Code ist im aktuellen Warenkorb noch kein Rabatt bestätigt. Bitte prüfe die Rabattbedingungen; Versand- und Kundenbedingungen können erst im Checkout feststehen.';
      }

      connectedCallback() {
        this.connectionVersion = (this.connectionVersion || 0) + 1;
        this.controller?.abort();
        this.observer?.disconnect();
        this.controller = new AbortController();
        this.input = this.querySelector('[data-input]');
        this.apply = this.querySelector('[data-apply]');
        this.status = this.querySelector('[data-status]');
        this.list = this.querySelector('[data-codes]');
        this.refresh = this.querySelector('[data-refresh]');
        this.root = (this.dataset.root || '/').replace(/\/?$/, '/');
        this.busy = false;
        this.generation = (this.generation || 0) + 1;
        const options = { signal: this.controller.signal };
        this.apply.addEventListener('click', () => this.update(this.input.value, false), options);
        this.input.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' && !event.isComposing) {
            event.preventDefault(); event.stopPropagation(); this.update(this.input.value, false);
          }
        }, options);
        this.list.addEventListener('click', (event) => {
          const button = event.target.closest('[data-remove-code]');
          if (button && this.list.contains(button)) this.update(button.dataset.removeCode, true);
        }, options);
        this.refresh.addEventListener('click', () => window.location.reload(), options);
        this.observer = new MutationObserver(() => {
          if (this.busy) return;
          clearTimeout(this.refreshTimer);
          this.refreshTimer = setTimeout(() => this.sync(), 150);
        });
        const items = document.getElementById('main-cart-items');
        if (items) this.observer.observe(items, { childList: true, subtree: true });
        window.addEventListener('pageshow', () => { if (!this.busy) this.sync(); }, options);
        this.restoreNotice();
        this.sync();
      }

      disconnectedCallback() {
        this.connectionVersion++;
        this.controller?.abort();
        this.observer?.disconnect();
        clearTimeout(this.refreshTimer);
        this.unlock();
        this.generation++;
      }

      async request(path, body) {
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 12000);
        try {
          const response = await fetch(this.root + path, {
            method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store',
            headers: { 'Accept': 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) },
            ...(body ? { body: JSON.stringify(body) } : {}), signal: controller.signal
          });
          const data = await response.json();
          if (!response.ok || data.errors || (Number(data.status) >= 400)) throw new Error('Cart request failed');
          return data;
        } finally { clearTimeout(timeout); }
      }

      async sync() {
        if (this.busy || !this.isConnected) return;
        const generation = ++this.generation;
        try {
          const cart = await this.request('cart.js');
          if (this.isConnected && !this.busy && generation === this.generation) this.renderCodes(cart);
        } catch (_) { /* Keep the working server-rendered cart; the apply action can retry. */ }
      }

      renderCodes(cart) {
        this.list.replaceChildren();
        FCDawn4.codes(cart).forEach((code) => {
          const item = document.createElement('li');
          item.className = 'fcd-pill';
          const label = document.createElement('span');
          label.textContent = code;
          const button = document.createElement('button');
          button.type = 'button'; button.className = 'fcd-remove';
          button.textContent = '×'; button.dataset.removeCode = code;
          button.setAttribute('aria-label', `Rabattcode ${code} entfernen`);
          button.disabled = this.busy;
          item.append(label, button); this.list.append(item);
        });
      }

      lock() {
        this.locked = [...document.querySelectorAll('cart-items, #main-cart-footer .cart__ctas, #main-cart-footer .cart__dynamic-checkout-buttons')]
          .map((node) => ({ node, inert: node.hasAttribute('inert') }));
        this.locked.forEach(({ node }) => node.setAttribute('inert', ''));
      }

      unlock() {
        (this.locked || []).forEach(({ node, inert }) => { if (!inert) node.removeAttribute('inert'); });
        this.locked = [];
      }

      setBusy(value) {
        this.busy = value;
        this.setAttribute('aria-busy', String(value));
        this.input.disabled = value;
        this.querySelectorAll('button').forEach((button) => { button.disabled = value; });
        this.apply.textContent = value ? 'Bitte warten …' : 'Einlösen';
      }

      async waitForQuantities() {
        // Dawn 4 debounces quantity changes for 300 ms. Let a pending blur/change finish.
        await new Promise((resolve) => setTimeout(resolve, 400));
        const deadline = Date.now() + 10000;
        while (document.querySelector('#main-cart-items.cart__items--disabled')) {
          if (Date.now() > deadline) throw new Error('Quantity update still pending');
          await new Promise((resolve) => setTimeout(resolve, 100));
        }
      }

      targets() {
        const items = document.getElementById('main-cart-items');
        const footer = document.getElementById('main-cart-footer');
        if (!items?.dataset.id || !footer?.dataset.id) return [];
        return [
          { id: 'main-cart-items', section: items.dataset.id },
          { id: 'main-cart-footer', section: footer.dataset.id }
        ];
      }

      renderSections(cart, targets) {
        if (targets.length !== 2) return false;
        const replacements = [];
        for (const target of targets) {
          const html = cart.sections?.[target.section];
          if (typeof html !== 'string') return false;
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const next = parsed.getElementById(target.id)?.querySelector('.js-contents');
          const current = document.getElementById(target.id)?.querySelector('.js-contents');
          if (!next || !current) return false;
          replacements.push({ current, html: next.innerHTML });
        }
        replacements.forEach(({ current, html }) => { current.innerHTML = html; });
        const cartItems = document.querySelector('cart-items');
        if (cartItems) {
          cartItems.classList.toggle('is-empty', cart.item_count === 0);
          cartItems.currentItemCount = cart.item_count;
        }
        document.getElementById('main-cart-footer')?.classList.toggle('is-empty', cart.item_count === 0);
        return true;
      }

      restoreNotice() {
        try {
          const value = sessionStorage.getItem('ft-dawn4-discount-notice');
          sessionStorage.removeItem('ft-dawn4-discount-notice');
          if (!value) return;
          const notice = JSON.parse(value);
          if (Date.now() - notice.time < 60000) this.status.textContent = notice.text;
        } catch (_) { /* Storage is optional. */ }
      }

      async update(value, removing) {
        if (this.busy) return;
        const connection = this.connectionVersion;
        const code = String(value || '').trim();
        if (!code || code.includes(',')) {
          this.status.textContent = 'Bitte einen einzelnen Rabattcode eingeben.';
          this.input.focus(); return;
        }
        this.generation++;
        this.setBusy(true);
        this.lock();
        this.refresh.hidden = true;
        this.status.textContent = 'Rabattcode wird geprüft …';
        let mutationSent = false;
        try {
          await this.waitForQuantities();
          if (!this.isConnected || connection !== this.connectionVersion) return;
          const before = await this.request('cart.js');
          if (!this.isConnected || connection !== this.connectionVersion) return;
          if (!before.item_count) {
            this.status.textContent = 'Bitte lege zuerst ein Produkt in den Warenkorb.'; return;
          }
          let codes = FCDawn4.codes(before).filter((item) => FCDawn4.normalize(item) !== FCDawn4.normalize(code));
          if (!removing) codes.push(code);
          const targets = this.targets();
          const payload = { discount: codes.join(',') };
          if (targets.length) {
            payload.sections = targets.map((target) => target.section);
            payload.sections_url = window.location.pathname;
          }
          const note = document.getElementById('Cart-note');
          if (note) payload.note = note.value;
          mutationSent = true;
          const cart = await this.request('cart/update.js', payload);
          if (!this.isConnected || connection !== this.connectionVersion) return;
          const message = FCDawn4.feedback(cart, code, removing);
          if (!this.renderSections(cart, targets)) {
            try { sessionStorage.setItem('ft-dawn4-discount-notice', JSON.stringify({ text: message, time: Date.now() })); } catch (_) {}
            this.status.textContent = 'Warenkorb wird aktualisiert …';
            window.location.reload(); return;
          }
          this.renderCodes(cart);
          this.status.textContent = message;
          if (removing || FCDawn4.codes(cart).some((item) => FCDawn4.normalize(item) === FCDawn4.normalize(code))) this.input.value = '';
        } catch (_) {
          if (!this.isConnected || connection !== this.connectionVersion) return;
          this.status.textContent = mutationSent
            ? 'Die Rückmeldung ist fehlgeschlagen. Bitte lade den Warenkorb neu, um Rabatt und Preise zu prüfen.'
            : 'Der Warenkorb konnte gerade nicht geprüft werden. Bitte versuche es gleich erneut.';
          this.refresh.hidden = !mutationSent;
        } finally {
          if (connection === this.connectionVersion) {
            this.unlock();
            if (this.isConnected) this.setBusy(false);
          }
        }
      }
    }
    customElements.define('ft-cart-discount-dawn4', FCDawn4);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["foto-slider-produkt"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ftkp-flex-slideshow')) {
    customElements.define('ftkp-flex-slideshow', class extends HTMLElement {
      connectedCallback() {
        this.initFrame = requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        if (!this.isConnected || this.controller) return;
        this.track = this.querySelector('[data-track]');
        if (!this.track) return;
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        if (!this.slides.length) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const listen = (target, type, callback, options = {}) => {
          if (target) target.addEventListener(type, callback, { ...options, signal });
        };
        this.index = 0;
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.counter = this.querySelector('[data-current]');
        this.status = this.querySelector('[data-status]');
        this.playButton = this.querySelector('[data-play]');
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.enabled = this.dataset.autoplay === 'true' && this.slides.length > 1;
        this.paused = !this.enabled || this.motion.matches || this.dataset.editor === 'true';
        this.hovering = false;
        this.onScreen = !('IntersectionObserver' in window);
        this.interval = Math.max(3000, Number(this.dataset.interval) || 5000);
        this.lastWidth = this.track.clientWidth;

        const controls = this.querySelector('[data-controls]');
        if (controls) controls.hidden = this.slides.length < 2;
        listen(this.querySelector('[data-previous]'), 'click', () => this.manualGo(this.index - 1));
        listen(this.querySelector('[data-next]'), 'click', () => this.manualGo(this.index + 1));
        this.dots.forEach((dot, index) => listen(dot, 'click', () => this.manualGo(index)));
        // Pointer focus pauses rotation before click. Preserve the user's
        // intended toggle so the first mouse click can actually pause it.
        listen(this.playButton, 'pointerdown', () => { this.playIntent = this.paused; });
        listen(this.playButton, 'pointercancel', () => { this.playIntent = null; });
        listen(this.playButton, 'keydown', () => { this.playIntent = null; });
        listen(this.playButton, 'click', () => {
          const wasPaused = typeof this.playIntent === 'boolean' ? this.playIntent : this.paused;
          this.playIntent = null;
          this.setPaused(!wasPaused);
        });
        listen(this, 'focusin', () => this.setPaused(true));
        listen(this, 'pointerenter', event => {
          if (event.pointerType !== 'mouse') return;
          this.hovering = true;
          this.schedule();
        });
        listen(this, 'pointerleave', event => {
          if (event.pointerType !== 'mouse') return;
          this.hovering = false;
          this.schedule();
        });
        listen(this.track, 'pointerdown', () => this.setPaused(true), { passive: true });
        listen(this.track, 'wheel', () => this.setPaused(true), { passive: true });
        listen(this.track, 'scroll', () => {
          clearTimeout(this.scrollTimer);
          this.scrollTimer = setTimeout(() => this.settle(), 120);
        }, { passive: true });
        listen(this.track, 'scrollend', () => this.settle());
        listen(this, 'keydown', event => {
          if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let next = this.index;
          if (event.key === 'ArrowLeft') next--;
          if (event.key === 'ArrowRight') next++;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.slides.length - 1;
          this.manualGo(next);
        });
        listen(document, 'visibilitychange', () => this.schedule());
        listen(this.motion, 'change', () => {
          if (this.motion.matches) this.setPaused(true);
        });
        listen(document, 'shopify:block:select', event => {
          if (!event.detail || event.detail.sectionId !== this.dataset.sectionId) return;
          if (event.detail.blockId !== this.dataset.sliderBlockId && !this.contains(event.target)) return;
          this.setPaused(true);
        });

        if ('IntersectionObserver' in window) {
          this.visibilityObserver = new IntersectionObserver(entries => {
            this.onScreen = entries[0].isIntersecting;
            this.schedule();
          }, { threshold: 0.05 });
          this.visibilityObserver.observe(this);
        }
        const onResize = () => {
          const width = this.track.clientWidth;
          if (width <= 0 || Math.abs(width - this.lastWidth) < 0.5) return;
          this.lastWidth = width;
          this.go(this.index, true);
        };
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(onResize);
          this.resizeObserver.observe(this.track);
        } else {
          listen(window, 'resize', onResize);
        }
        this.go(0, true);
        this.updatePlayback();
        this.schedule();
      }

      manualGo(index) {
        this.setPaused(true);
        this.go(index);
      }

      go(index, instant = false) {
        clearTimeout(this.scrollTimer);
        this.index = (index + this.slides.length) % this.slides.length;
        const left = this.slides[this.index].offsetLeft - this.slides[0].offsetLeft;
        this.track.scrollTo({ left, behavior: instant || this.motion.matches ? 'auto' : 'smooth' });
        this.updateSlides();
      }

      settle() {
        clearTimeout(this.scrollTimer);
        if (!this.controller || this.track.clientWidth <= 0) return;
        const left = this.track.scrollLeft;
        const start = this.slides[0].offsetLeft;
        let closest = 0;
        let distance = Infinity;
        this.slides.forEach((slide, index) => {
          const next = Math.abs(slide.offsetLeft - start - left);
          if (next < distance) { closest = index; distance = next; }
        });
        this.index = closest;
        this.updateSlides();
      }

      updateSlides() {
        this.slides.forEach((slide, index) => {
          const active = index === this.index;
          if (!active && slide.contains(document.activeElement)) this.track.focus({ preventScroll: true });
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          slide.querySelectorAll('a').forEach(link => { link.tabIndex = active ? 0 : -1; });
        });
        this.dots.forEach((dot, index) => {
          if (index === this.index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        if (this.counter) this.counter.textContent = String(this.index + 1);
        if (this.status && this.paused) {
          const message = 'Bild ' + (this.index + 1) + ' von ' + this.slides.length;
          if (this.status.textContent !== message) this.status.textContent = message;
        }
      }

      setPaused(paused) {
        this.paused = paused;
        this.updatePlayback();
        this.schedule();
      }

      updatePlayback() {
        if (!this.playButton) return;
        this.playButton.setAttribute('aria-label', this.paused ? 'Automatischen Bildwechsel starten' : 'Automatischen Bildwechsel pausieren');
        this.playButton.querySelector('[data-play-icon]').hidden = !this.paused;
        this.playButton.querySelector('[data-pause-icon]').hidden = this.paused;
      }

      schedule() {
        clearTimeout(this.timer);
        if (!this.controller || !this.enabled || this.paused || this.hovering || !this.onScreen || document.hidden) return;
        this.timer = setTimeout(() => {
          this.go(this.index + 1);
          this.schedule();
        }, this.interval);
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        clearTimeout(this.timer);
        clearTimeout(this.scrollTimer);
        if (this.controller) this.controller.abort();
        this.controller = null;
        if (this.visibilityObserver) this.visibilityObserver.disconnect();
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
